import keplerGlReducer, {KeplerGlState} from '@kepler.gl/reducers';
import {Reducer} from "@reduxjs/toolkit";

export const customizedKeplerGlReducer: Reducer<{ map: KeplerGlState; }> = keplerGlReducer.initialState({
    mapStyle: {
        styleType: 'dark',
    }
});